import EntityTable from "@mirage/components/entityTable/EntityTable";
import LinkCell from "@mirage/components/entityTable/components/LinkCell";
import { Box } from "@mui/system";
import { GridRenderCellParams } from "@mui/x-data-grid-premium";
import CompetentPersonsSchemeService from "@publicPortal/services/CompetentPersonsSchemeService";
import { PublicPortalRoutingService } from "@publicPortal/services/PublicPortalRoutingService";
import { IEntityPageRequest } from "@shared/mirage/core/contracts/IEntityPageRequest";
import React, { memo, useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { SearchResultTableProps } from "./PlanningApplicationsTable";
import { IBcCompetentPersonSchema } from "@shared/publicportal/entities/IBcCompetentPersonSchema";

const pp = new PublicPortalRoutingService();
const service = new CompetentPersonsSchemeService();

const CompetentPersonsSchemeTable: React.FC<SearchResultTableProps> = memo(({ filter, title, customPageRequest }) => {
    const navigate = useNavigate();
    const getRecordDetailRoute = useCallback((id: number) => {
        return pp.CompetentPersonsSchemeRecordRoute(id);
    }, []);
    const columns = useMemo(() => {
        return [
            {
                field: "uniqueId",
                headerName: "Unique Id",
                renderCell: (params: GridRenderCellParams) => <LinkCell value={params.value} route={getRecordDetailRoute(Number(params.id))} />,
                flex: 0.25,
            },
            { field: "description", headerName: "Description", flex: 1 },
            { field: "installer", headerName: "Installer", flex: 0.25 },
            { field: "dateStarted", headerName: "Date Started", flex: 0.25, type: "date" },
            { field: "dateCompleted", headerName: "Date Completed", flex: 0.25, type: "date" },
        ];
    }, []);
    const onRecordSelected = useCallback(
        (record: IBcCompetentPersonSchema) => {
            navigate(getRecordDetailRoute(record.id));
        },
        [getRecordDetailRoute, navigate]
    );
    const pageRequest = useCallback(
        async (pageRequest: IEntityPageRequest) => {
            if (customPageRequest) {
                return await customPageRequest(pageRequest);
            }
            const response = await service.pageRequest(pageRequest);
            return response;
        },
        [customPageRequest]
    );
    return (
        <Box sx={{ marginTop: "32px", height: "auto" }}>
            <EntityTable
                title={title}
                key="competentPersonsSchema-entityTable"
                stateKey="competentPersonsSchema-entityTable-stateKey"
                onPageRequest={pageRequest}
                columns={columns}
                filter={filter}
                onRecordSelected={onRecordSelected}
            />
        </Box>
    );
});

export default CompetentPersonsSchemeTable;
